import { useEffect } from "react";
import { Link } from "react-router-dom";

/**
 * SSR/SSG-safe redirect element.
 *
 * Why: Rendering <Navigate> during server-side prerender can throw and abort
 * the `vite-react-ssg build`. This component renders a static fallback on the
 * server and performs the redirect only on the client.
 */
export default function LegacyRedirectElement({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <main className="min-h-screen bg-background text-foreground pt-24 pb-16 px-4">
      <div className="max-w-3xl mx-auto text-center">
        <h1 className="text-2xl font-serif text-foreground mb-3">Weiterleitung…</h1>
        <p className="text-sm text-muted-foreground">
          Falls die Weiterleitung nicht automatisch funktioniert, klicke bitte{" "}
          <Link to={to} className="text-mif hover:underline">
            hier
          </Link>
          .
        </p>
      </div>
    </main>
  );
}
